
export const UPDATE_CATEGORY_INFO = "UPDATE_CATEGORY_INFO";
export const SET_EDITING_CATEGORY_INFO = "SET_EDITING_CATEGORY_INFO";

// 수정 시작
export const START_EDIT_MODE = "START_EDIT_MODE";

// 수정 종료
export const END_EDIT_MODE = "END_EDIT_MODE";

// 루트 카테고리의 하위 0번째 인덱스로 카테고리 추가
export const PREPEND_AT_ROOT_CATEGORY = "PREPEND_AT_ROOT_CATEGORY";

// 루트 카테고리의 하위 마지막 인덱스로 카테고리 추가
export const APPEND_AT_ROOT_CATEGORY = "APPEND_AT_ROOT_CATEGORY";

// 카테고리 추가
export const APPEND_CATEGORY = "APPEND_CATEGORY";

// 카테고리 삭제
export const REMOVE_CATEGORY = "REMOVE_CATEGORY";

// 카테고리 정보 초기화
export const INIT_CATEGORY = "INIT_CATEGORY";

// 전체 카테고리 열기
export const OPEN_ALL_SUB_CATEGORY = "OPEN_ALL_SUB_CATEGORY ";

// 전체 카테고리 닫기
export const CLOSE_ALL_SUB_CATEGORY = "CLOSE_ALL_SUB_CATEGORY";

// 하위 카테고리 열기
export const OPEN_SUB_CATEGORY = "OPEN_SUB_CATEGORY";

// 하위 카테고리 닫기
export const CLOSE_SUB_CATEGORY = "CLOSE_SUB_CATEGORY";

// 전체 카테고리 변경사항 저장
export const UPDATE_CATEGORY_TREE = "UPDATE_CATEGORY_TREE";

// 카테고리 이름 업데이트
export const UPDATE_CATEGORY_NAME = "UPDATE_CATEGORY_NAME";

// 카테고리 채널 연결 업데이트
export const UPDATE_CATEGORY_VIEW_CHANNEL = "UPDATE_CATEGORY_VIEW_CHANNEL";

// 카테고리 이동
export const MOVE_CATEGORY = "MOVE_CATEGORY";

// 루트 카테고리(top category) 이름 변경
export const UPDATE_ROOT_CATEGORY_LABEL = "UPDATE_ROOT_CATEGORY_LABEL";

// 카테고리 visibility 변경
export const UPDATE_CATEGORY_VISIBILITY = "UPDATE_CATEGORY_VISIBILITY";
